export default __webpack_public_path__ + "static/media/logoInstagram.0963b7a5.png";